import { UrlParamTypes } from '../enums/UrlParamTypes';
const getJsonnetData = (baseUrl, brand, region, country, language) => {
    let jsonURL = `${baseUrl}/${brand}-${region}-${country}-${language}.json`;
    const dxpPreview = new URLSearchParams(window.location.search).get(UrlParamTypes.DXP_PREVIEW);
    if (dxpPreview) {
        jsonURL += `?${UrlParamTypes.DXP_PREVIEW}=${dxpPreview}`;
    }
    return fetch(jsonURL);
};
export default getJsonnetData;
//# sourceMappingURL=getJsonnetData.js.map